import { Plugin } from 'chart.js';

/** Matches analytics module Leads Types pie-chart legend layout. */
export function createCampaignDonutLegendPlugin(
  legendHostId: string,
  canvasId: string
): Plugin<'doughnut'> {
  return {
    id: `campaignDonutLegend_${legendHostId}`,
    afterInit(chart) {
      if (chart.canvas.id !== canvasId) return;

      const legendHost = document.getElementById(legendHostId);
      if (!legendHost) return;

      const ul = document.createElement('ul');
      ul.style.listStyle = 'none';
      ul.style.display = 'flex';
      ul.style.flexDirection = 'column';
      ul.style.position = 'static';
      ul.style.alignItems = 'flex-start';
      ul.style.fontSize = '14px';
      ul.style.gap = '10px';
      ul.style.margin = '0';
      ul.style.padding = '0';

      chart.data.labels?.forEach((label, index) => {
        const dataset = chart.data.datasets[0];
        const colors = dataset.backgroundColor;
        const color = Array.isArray(colors) ? colors[index] : colors;
        const value = dataset.data[index];

        ul.innerHTML += `
          <li>
            <div style="display: flex; flex-direction: row; padding: 5px;">
              <div style="width: 17px; margin-right: 12px; height: 19px; margin-top: 5px; padding: 5px; background-color: ${color}"></div>
              <div style="color: gray; margin-top: 4px; display: flex; gap: 15px">
                <div style="margin-left: 11px; color: #000">${value}</div>
                ${label}
              </div>
            </div>
          </li>
        `;
      });

      legendHost.innerHTML = '';
      legendHost.appendChild(ul);
    }
  };
}

export const campaignDonutChartOptions = {
  responsive: true,
  maintainAspectRatio: true,
  plugins: {
    legend: { display: false },
    title: { display: false }
  },
  scales: {
    x: {
      border: { display: false },
      grid: { display: false },
      ticks: { display: false }
    },
    y: {
      border: { display: false },
      grid: { display: false },
      ticks: { display: false }
    }
  }
};
